module.exports = __webpack_public_path__ + "static/media/builder.3aebab79.jpg";